import styled from 'styled-components';

import { TextInput } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../../translations';

import { EzwmSenderCodeFormController } from './EzwmSenderCode.types';

type EzwmSenderCodeInputProps = {
   readonly register: EzwmSenderCodeFormController['register'];
};

const SENDER_CODE_REGEX = /^[A-Z0-9]+$/u;
const SENDER_CODE_LENGTH = 8;

const validationRules = {
   validate: (data: unknown) => {
      const currentValue = data as string | null;
      if (!currentValue || currentValue.length !== SENDER_CODE_LENGTH || !SENDER_CODE_REGEX.test(currentValue)) {
         return nfzSettingsTranslationKeys.incorrectSenderCode;
      }
      return undefined;
   },
};

const StyledTextInput = styled(TextInput)`
   width: initial;
`;

export const EzwmSenderCodeInput = (props: EzwmSenderCodeInputProps): JSX.Element => {
   return (
      <StyledTextInput
         testId={'senderCode'}
         controller={props.register('senderCode', validationRules)}
         label={nfzSettingsTranslationKeys.senderCodeForEzwm}
         size={SENDER_CODE_LENGTH}
      />
   );
};
